import _ from "underscore";
import $ from "jquery";
import render from "../../utilities/render";
import {setElementsFromScope, show, hide, insertTextAndClean, combineElements, setUniqNamesAndIds} from "../../utilities/selectorHelpers";
import {createPreventDefault, isPresent, isTruthy, isBlank} from '../../utilities/general';
const elementsMap = {
    facilitieslist: '#facilitieslist',
    fscfacilitesuses:'#fscfacilitesuses',
    fscFacilityType:'.fscFacilityType',
    fscBussinesUnitMsg:'.fsc-bussines-unit-msg',
    savedFacilities:'#savedfacilities',
  };

export default function FscFacilitiesTab(wizard){
    const self = this;
    const wizardElement = wizard.getWizardElement();
    const els = {};
    const fscFacilitiesTab = wizardElement.find('.fscFacilities-tab');
    const facilities = wizardElement.data('facilities');
    const facilityTypes = wizardElement.data('facility-types');
    const getfacilitesconfigurations = wizardElement.data('getfacilitesconfigurations');
    let savedFacilitiesArray =[];
    let savedFacilityBussinessUnit;
    self.init = function(){
      renderFscFacilitiesTab();
    };
    function renderFscFacilitiesTab(){
      setElements();
      setUniqNamesAndIds(els);
      loadDropDowns();
      bindElements();
      hide(els.fscBussinesUnitMsg);
      
    }
    function setElements(){
        setElementsFromScope(els, elementsMap, fscFacilitiesTab);  
    }
    function loadDropDowns() {
        $(facilities).each(function(){
          var option = $('<option />');
          var optionvalue =this.facCode+"-"+this.facName
          option.attr('value', this.facId).text(optionvalue);
          els.facilitieslist.append(option);
        });
    }

    function bindElements() {
      els.facilitieslist.on("change", facilitiesConfigure);
      $(document).on("click", '.fscFacilities-tab .fscFacilityType', handleAddFacilityBtn);
      $(document).on("click", '.fscFacilities-tab .remove-facility-btn', handleRemoveFacilityBtn);
      $(document).on("click", '.fscFacilities-tab .add-facility-btn', handleSavedAddFacilityBtn);
      $(document).on("click", '.fscFacilities-tab .saved-facility-remove-btn', handleRemoveSavedFacilityBtn);
    }
    function handleAddFacilityBtn(){
        let value =$('[name="facilityType"]:checked').length;
        let atLeastOneFacUse = wizardElement.find('.fscFacilities-tab .select-atleastone-facuse');
        let addFacilityBtn = wizardElement.find('.fscFacilities-tab .add-facility-btn');
        if(value>0){
          addFacilityBtn.attr("disabled",false);
          hide(atLeastOneFacUse);
        }else{
          addFacilityBtn.attr("disabled",true);
          show(atLeastOneFacUse);
        }
    }
    function handleRemoveFacilityBtn(){
        els.facilitieslist.val('').trigger('change')
        hide(els.fscBussinesUnitMsg);
        hide(els.fscfacilitesuses);
    }
    function facilitiesConfigure() {
        let facid = els.facilitieslist.find('option:selected').val();
        if(facid){
        $.ajax({
            url: getfacilitesconfigurations,
            data: {
                facid:facid,
              },
            type: 'GET',
            success: function (data) {
                getRenderedFSCFacility(data);
            }
         });
         show(els.fscfacilitesuses);
        }
    }
    function getRenderedFSCFacility(data){
        data = JSON.parse(data);
        let facilities=data[0].facilityaddress;
        let bussunit= $('.fsc-business-unit').find('option:selected').val();
        savedFacilityBussinessUnit=facilities.facBusinessUnit;
          if(facilities.facBusinessUnit !== bussunit ){
            show(els.fscBussinesUnitMsg);
          }else{
            hide(els.fscBussinesUnitMsg);
          }
      const fscFacilitiesConfigurationHtml = $(render(require('./html/fscFacilitiesConfiguration.html'),{ 
        facilitiesConfig:facilities,
        facilityTypes: getRenderedFacilityTypes(facilityTypes),
      }));
      els.fscfacilitesuses.html(fscFacilitiesConfigurationHtml);
      loadOperationsandSqrtFootValues(facilities);
      handleAddFacilityBtn();
    } 
    function getRenderedFacilityTypes(facilityTypes) {
      const facilityTypeHtml = require("./html/facilityType.html");
       const response = _.map(facilityTypes, (facility) => {
        return render(facilityTypeHtml, {
          facility: facility
        });
      });
      return response.join(""); 
    }

    function handleSavedAddFacilityBtn(e){
      e.preventDefault();
      let checkedfacilitiesuses = [];
      $.each($('[name="facilityType"]:checked'), function(){
        checkedfacilitiesuses.push($(this).val());
      });
      let facid = els.facilitieslist.find('option:selected').val();
      let facilityname=els.facilitieslist.find('option:selected').text();
     // let selectedbussinessunit=$('.fsc-business-unit').find('option:selected').val();
      let facilitiesuses=checkedfacilitiesuses.join(", ");
      let objexist=true;
      let savedfacilityobj={
          facid:facid,
          facilityname:facilityname,
          selectedbussinessunit:savedFacilityBussinessUnit,
          facilitiesuses:facilitiesuses
      }
      if(savedFacilitiesArray.length == 0)
       savedFacilitiesArray.push(savedfacilityobj);
      for (var i in savedFacilitiesArray) {
          if (savedFacilitiesArray[i].facid == facid) {
            //savedFacilitiesArray[i].selectedbussinessunit = selectedbussinessunit;
             savedFacilitiesArray[i].facilitiesuses = facilitiesuses;
             objexist=false;
             break;
        }
     }
     if(objexist){
       savedFacilitiesArray.push(savedfacilityobj);
    }
      const savedFacilitiesHtml= getRenderedSavedFacilities(savedFacilitiesArray);
      els.savedFacilities.html(savedFacilitiesHtml);
      //handleRemoveFacilityBtn();
    }
    function getRenderedSavedFacilities(savedFacilitiesArray) {
      const savedFacilitiesHtml = require("./html/savedFacilities.html");
       const response = _.map(savedFacilitiesArray, (obj,index) => {
        return render(savedFacilitiesHtml, {
          savedobject: obj,
          index:index,
        });
      });
      return response.join("");
    }
    function handleRemoveSavedFacilityBtn(e){
      e.preventDefault();
      let index=$(this).attr('id');
      savedFacilitiesArray.splice(index, 1);
      const savedFacilitiesHtml= getRenderedSavedFacilities(savedFacilitiesArray);
      els.savedFacilities.html(savedFacilitiesHtml);
    }
    function loadOperationsandSqrtFootValues(facData){
      
      if(facData != null && facData != ''){
        const facAttributesData = new Set(facData.facilitiesAttributesSet);
        for (let keyval of facAttributesData) {
          let arr_names = new Array(keyval);
          for(let j=0;j<arr_names.length;j++){
            let attrName;
            let attrValue;
            for (let k of Object.keys(arr_names[j])) {
              if(k == "faaKey"){
                attrName = (arr_names[j])[k];
              }else if(k == "faaValue"){
                attrValue = (arr_names[j])[k];
              }
   
             }
             if(attrName!=null && attrValue!=null){
              if(attrName == "FAC_USE_ATTR"){
                let fcyuseselement = wizardElement.find('.fscFacilities-tab .fscFacilityType');
                _.each(fcyuseselement, (el)=>{
                  const ele = $(el);
                  if(ele.val() == attrValue){
                    ele.prop('checked', true);
                  }
                });
              }
            }
          }
        }
      }
   
    }
  
}


// WEBPACK FOOTER //
// ./src/pages/maintainRetailer/FscFacilitiesTab.js